import {
  SidePanel,
  ButtonPrimary,
  ButtonSecondary,
  PermissionEnum,
  PermissionDenied,
} from '@ui/src';
import AccountForm from '../../../components/charts/charts-panel/charts-panel-account';
import usePrimaryAccountCreate from './hooks/use-create';

import cn from '../styles.module.css';

const PrimaryAccountCreate = (): React.JSX.Element => {
  const {
    typeOptions,
    accounts,
    activePermissions,
    globalError,
    requestInProgress,
    category,
    control,
    errors,
    setValue,
    description,
    onSubmit,
    groups,
    groupId,
    panelIsOpen,
    handleClose,
  } = usePrimaryAccountCreate();

  let content;

  if (
    !activePermissions?.includes(
      PermissionEnum.ACCOUNTS_CHART_ADD_PRIMARY_ACTION,
    )
  ) {
    content = <PermissionDenied />;
  } else {
    content = (
      <AccountForm
        category={category}
        name={description}
        control={control}
        group={groups?.find((group) => groupId === group.id)}
        errors={errors}
        typeOptions={typeOptions}
        setValue={setValue}
        accountNumber={
          (accounts?.length as number) > 9
            ? accounts?.length.toString()
            : `0${accounts?.length}`
        }
        isEditable={activePermissions?.includes(
          PermissionEnum.ACCOUNTS_CHART_ADD_PRIMARY_ACTION,
        )}
      />
    );
  }

  return (
    <SidePanel
      closeOnClickOutside={false}
      isOpen={panelIsOpen}
      onClose={handleClose}
      parent={document.getElementById('chart-modal') as HTMLElement}
      title="Account Add"
      className={cn.chartSidePanel}
      sidepanelExpandedKey="charts-account-create"
      errorSidepanel={globalError}
      withoutExpand
      footer={
        <>
          {activePermissions?.includes(
            PermissionEnum.ACCOUNTS_CHART_ADD_PRIMARY_ACTION,
          ) && (
            <ButtonPrimary
              text={requestInProgress ? 'Loading...' : 'Save'}
              disabled={requestInProgress}
              onClick={onSubmit}
            />
          )}
          <ButtonSecondary text="Close" onClick={handleClose} />
        </>
      }
    >
      {content}
    </SidePanel>
  );
};

export default PrimaryAccountCreate;
